// extracted by css-extract-rspack-plugin
export default {"ChecksStatusBadge":"AsyncChecksStatusBadge-module__ChecksStatusBadge__wbwBt"};